import apiRequest from '@libs/apiRequest';
import { getFormValues } from 'redux-form';
import { call, put, select } from 'redux-saga/effects';
import { FORM_NAME } from "leaveManagement/common";
import { setLoading, setSnack } from 'utilities/redux.actions';
import dayjs from 'dayjs';

export default function* (action) {
    const {
        meta: { handleSubmit = () => { } },
        ...rest
    } = action;

    const { employeeEmail, endDate, startDate, totalNumberOfDays, reason, isEmergency, employeesToNotify, category, requiredDocuments } = yield select(
        getFormValues(FORM_NAME)
    );
    let allSelector = {
        employeeEmail,
        endDate: dayjs(endDate).format('YYYY-MM-DD'),
        startDate: dayjs(startDate).format('YYYY-MM-DD'),
        totalNumberOfDays,
        reason,
        employeesToNotify: employeesToNotify ? employeesToNotify.map(({ email }) => {
            return { user: { email: email || "" } }
        }) : {},
        category: {
            name: category
        },
        isEmergency,
        requiredDocuments
    }

    let formData = new FormData();
    FormData_append_object(formData, allSelector);
    yield put(setLoading(true));

    try {
        const { data } = yield call(
            apiRequest,
            {
                url: "leave",
                method: 'post',
                data: formData,
            }
        );
        yield put(setLoading(false));
        yield put(setSnack({
            message: "Leave created successfully",
            type: 'success',
        }));

        return handleSubmit(data);
    } catch (error) {
        yield put(setLoading(false));
        yield put(setSnack({
            message: error?.response?.data?.message || error?.message,
            type: 'error',
        }));
        // return handleSubmit(error);
    }
}

function FormData_append_object(fd, obj, key) {
    var i, k;
    for (i in obj) {
        k = key ? key + '[' + i + ']' : i;
        if (!obj[i])
            continue;
        if (typeof obj[i] == 'object') {
            if (obj[i].type === "file") {
                fd.append(k, obj[i].file);
            } else {
                FormData_append_object(fd, obj[i], k);
            }
        }
        else
            fd.append(k, obj[i]);
    }
}
